
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class TaskTypeDialog extends SiteEntityDialog<TaskTypeRow, any> {
        protected getFormKey() { return TaskTypeForm.formKey; }
        protected getIdProperty() { return TaskTypeRow.idProperty; }
        protected getLocalTextPrefix() { return TaskTypeRow.localTextPrefix; }
        protected getNameProperty() { return TaskTypeRow.nameProperty; }
        protected getService() { return TaskTypeService.baseUrl; }

        protected form = new TaskTypeForm(this.idPrefix);

        constructor() {
            super();

            $(window).on('resize.' + this.uniqueName, () => this.arrange());
        }

        destroy() {
            $(window).off('.' + this.uniqueName);
            super.destroy();
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.form.Properties.taskTypeCode = this.entityId;
            this.form.TaskMap.taskTypeCode = this.entityId;
            this.updateInterface();
        }

        protected updateInterface() {
            super.updateInterface();

            this.form.TaskMap.set_readOnly(this.form.TaskMap.get_readOnly() || this.isNew());
            this.form.Properties.set_readOnly(this.form.TaskMap.get_readOnly() || this.isNew());
        }

        protected arrange() {
            super.arrange();
            var availHeight = $(window).height() - 280;
            this.form.TaskMap.element.css('height', Math.max(150, availHeight) + 'px').trigger('layout');
            this.form.Properties.element.css('height', Math.max(150, availHeight) + 'px').trigger('layout');
        }
    }
}